import { MasterViewModel, WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class StatusInspectionStoreService {
  _status$ = new BehaviorSubject<MasterViewModel[]>(null);

  constructor(private inspectionService: WalkAndPunchApiClient) {}

  loadStatus() {
    return this.inspectionService.v1InspectionGetInspectionStatusesGET();
  }

  getData(): MasterViewModel[] {
    return this._status$.getValue();
  }

  get status() {
    return this._status$.value;
  }

  set status(data: MasterViewModel[]) {
    this._status$.next(data);
  }

  get status$() {
    return this._status$;
  }
}
